/**
 * api接口统一管理
 * 三期案例代码
 */
import {
  Header,
  getV2,
  postV2,
  delV2,
  get,
  getV2Patent,
  post
} from './http';

/*
  案例代码:
  1.因为多家协同开发  每家公司单独建立各自的api 请求文件 然后通过公用http.js 封装请求脚本 导入 get post等方法
  
  2.多家开发 涉及多个不同后台 可能存在后台地址不一样 通过导入http->Header 定义不同的 接口地址
  此例  header.client 代表 中经社三期项目组后台url地址(可设多个),在http中有定义  
  上线后 可手动在 static/config.js中更改
*/

export const getNation = id => getV2(Header.v2Client + `/dic/nation/${id}`);

/**
 * @description company相关
 */
// 获取股票交易所
export const getExchanges = () => getV2(Header.v2Client + "/dic/exchanges");

//获取公司左侧菜单
export const getCompanyList = params => postV2(Header.v2Client + "/company/query", params)

//获取basic
export const getBasic = (id, code) => getV2(Header.v2Client + `/company/basicDetail/${id}/${code}`)

//获取Corporate 股东信息 0历史股东  1当前股东
export const getCorporateShareHolders = params => postV2(Header.v2Client + "/company/shareholders", params);

//获取股东分页信息
export const getShareHoldersPage = params => postV2(Header.v2Client + "/company/shareholder", params);

/**
 * @description 企业财务相关
 */
export const getCompanyFinancial = params => postV2(Header.v2Client + "/company/financials", params);

//企业listed
export const getCompanyFinancialListed = f10Id => getV2(Header.v2Client + `/company/financialsListed/${f10Id}`);

// k图
// export const getKQuotation = f10DataId => get(Header.v2Client + `/company/quotation/${f10DataId}`);
export const getKQuotation = params => postV2(Header.v2Client + `/company/quotation`, params);


// op dividend
export const getDividend = params => postV2(Header.v2Client + `/company/dividend`, params);

// op summary 公告信息
export const getSummary = params => postV2(Header.v2Client + `/company/summary`, params);

// 并购交易
export const getZephyrList = params => postV2(Header.v2Client + `/zephyr/query`, params);

// overView
export const getZephyrOverview = fid => getV2(Header.v2Client + `/zephyr/overview/${fid}`);

//Structure
export const getZephyrStructure = fid => getV2(Header.v2Client + `/zephyr/structure/${fid}`);

// multiples
export const getAllmultiples = fid => getV2(Header.v2Client + `/zephyr/multiples/${fid}`);

// stockPrice
export const getStockPrice = fid => getV2(Header.v2Client + `/zephyr/stockPrice/${fid}`);

/**
 * @description行业
 */
export const getIndictorsList = params => postV2(Header.v2Client + "/industry/getIndictors", params);

export const getIndictorsTree = (parentId, level) => getV2(Header.v2Client +
  `/industry/IndictorsTree/${parentId}/${level}`);

export const getIndictorsData = params => postV2(Header.v2Client + "/industry/getIndictorsData", params);

/**
 * @description 宏观
 */
export const getMacroCommon = params => postV2(Header.v2Client + "/macro/commonApi", params);

export const getCountryList = params => getV2(Header.v2Client + "/dic/countries")

/**
 * @description 权限相关
 */
// export const getAllPermission = params => postV2(Header.v2Client + `/user/init`, params);
export const getAllPermission = params => postV2("http://xhapp.xhsl.xhszjs.cn/endata" + `/user/init`, params);
/**
 * @description 权限相关 新
 */
export const getAllPermissionNew = params => postV2(Header.xhClient + `/V2Indics/user/cninit`, params);
/**
 * @description 收藏
 * */
//收藏
export const postSaveFavourite = params => postV2(Header.v2Client + "/favorite/save", params);
//获取收藏信息
export const getFavouriteStatus = (companyId, userId) => postV2(Header.v2Client +
  `/favorite/collect/${companyId}/${userId}`);
// 取消收藏
export const delFavouriteData = id => delV2(Header.v2Client + `/favorite/del/${id}`);
//根据id获取详情
export const getFavouriteDetail = id => getV2(Header.v2Client + `/favorite/detail/${id}`);

/**
 * @description 主页
 */
export const getTotalData = () => getV2(Header.v2Client + "/home/total");

export const getHomeCompany = () => getV2(Header.v2Client + "/home/company");

export const getIndustryData = () => getV2(Header.v2Client + "/home/industry");

export const getTranscationData = () => getV2(Header.v2Client + "/home/transaction");

export const getMacroData = () => getV2(Header.v2Client + "/home/macro");

/**
 * @description 专利
 */
export const getPatentList = params => postV2(Header.v2Client + "/patent/query", params);

export const getPatentDetail = id => getV2(Header.v2Client + `/patent/detail/${id}`);



